<template>
  <div class="judgeReScoreDetail">
    <div class="searchBox">
      <a-row :gutter="24">
        <a-col :span="24">
          <div style="line-height: 32px;">{{ $t('admin-judge/tip12') }}：<font color="#ff0000"><b>{{ result.total }}</b></font> {{ result.total > 1 ? $t('admin-judge/pieces') : $t('admin-judge/piece') }}，{{ $t('admin-judge/tip13') }} <font color="#ff0000"><b>{{ result.review_num }}</b></font> {{ result.review_num > 1 ? $t('admin-judge/pieces') : $t('admin-judge/piece') }}，{{ $t('admin-judge/tip14') }} <font color="#ff0000"><b>{{ result.no_review_num }}</b></font> {{ result.no_review_num > 1 ? $t('admin-judge/pieces') : $t('admin-judge/piece') }}。</div>
        </a-col>
      </a-row>
    </div>

    <!-- 过滤区（迁移自初评评分页） -->
    <div v-show="!showDetail" class="searchBox">
      <!-- 评委选择，移动到类别前，同一行显示 -->
      <div v-if="user.role !== 3" style="width: 300px;display: flex;position: relative;float: left;margin-right: 10px;">
        <div class="tag" style="width: 5em">
          {{ $t('admin-judge/judge') }}
        </div>
        <a-select
          v-model="user_id"
          style="width: 200px;"
          @change="changePerson"
        >
          <a-select-option
            v-for="item in users"
            :key="item.id"
            :value="item.id"
          >
            {{ item.name }}
          </a-select-option>
        </a-select>
      </div>

      <div style="width: 340px;display: flex;position: relative;float: left;">
        <!-- 类别 -->
        <div class="tag" style="width: 5em">
          {{ $t('admin-profile-product/type') }}
        </div>
        <a-select
          v-model="cate_ids"
          style="width: 245px;overflow:hidden;"
          @change="changeCateId"
        >
          <a-select-option
            v-for="item in cates"
            :key="item.value"
            :value="item.value"
          >
            {{ item.name }}
          </a-select-option>
        </a-select>
      </div>
      <div style="display: flex;position: relative;float: left;margin-right: 10px;">
        <!-- 名称/编号搜索 -->
        <div class="tag" style="width: 5em">
          {{ $t('admin-message-message/name') }}
        </div>
        <div>
          <a-input
            v-model="searchWord2"
            :placeholder="$t('admin-judge/codeOrName')"
            @change="changeWord"
          />
        </div>
      </div>
      <div>
        <!-- 搜索 -->
        <a-button
          type="primary"
          @click="searchWord = searchWord2"
        >
          {{ $t('user-productInfo-myProduct/search') }}
        </a-button>
        <!-- 查看评审情况 -->
        <a-button
          type="primary"
          style="margin-left: 10px;"
          @click="showReviewStatus"
        >
          查看评审情况
        </a-button>
      </div>
      <div style="clear: both;" />
    </div>

    <!-- 表格（迁移自初评评分页） -->
    <a-table
      v-show="!showDetail"
      :columns="columns"
      :data-source="listFilter"
      class="table"
      :pagination="pagination"
      row-key="id"
      style="padding-bottom:20px"
      :scroll="{ y: 'calc(100vh - 230px)' }"
      @change="getList"
    >
      <!-- 序号 -->
      <span slot="index" slot-scope="text, row, index">
        <div>
          {{ index + 1 + (pagination.current - 1) * 10 }}
        </div>
      </span>
      <!-- 类别 -->
      <span slot="category" slot-scope="text">
        <div>
          {{ catesFormat[text] }}
        </div>
      </span>
      <!-- 作品图片 -->
      <span slot="image" slot-scope="text">
        <div style="position:relative;z-index:9">
          <img :src="text[0] && (text[0].thumb_image_url || text[0].whole_image_url)" alt height="50" style="cursor: pointer;" @click="preview(text)">
        </div>
      </span>
      <!-- 作品编号 -->
      <span slot="code" slot-scope="text, row">
        <div style="cursor: pointer;" @click="view(row)">{{ text }}</div>
      </span>
      <!-- 作品名称中文 -->
      <span slot="name_cn" slot-scope="text, row">
        <div style="cursor: pointer;" @click="view(row)">{{ text }}</div>
      </span>
      <!-- 作品名称英文 -->
      <span slot="name_en" slot-scope="text, row">
        <div style="cursor: pointer;" @click="view(row)">{{ text }}</div>
      </span>
      <!-- 分数-显示 -->
      <span slot="score" slot-scope="text">
        <div>
          {{ text }}{{ $t('admin-judge/points') }}
        </div>
      </span>
      <!-- 反馈 -->
      <span slot="feedback" slot-scope="text">
        <div style="overflow: hidden;text-overflow:ellipsis;white-space:nowrap;cursor: pointer;" @click="content = text;showModal2 = true">{{ text || '' }}</div>
      </span>
    </a-table>

    <!-- 提交按钮（迁移自初评评分页，文案改为复评） -->
    <!-- 已移除 完成本轮复评 按钮 -->

    <div style="height: 30px;" />

    <!-- 预展示图片组件 -->
    <PreviewImage v-if="previewVisible" :images="images" :index="imagesIndex" @closePreview="closePreview" />

    <!-- 评审情况弹窗 -->
    <Modal
      :show-modal="showReviewStatusModal"
      :cancel-text="$t('register-verify/close')"
      @cancel="showReviewStatusModal = false"
    >
      <div>
        <div style="font-size: 16px; font-weight: bold; margin-bottom: 15px;">评审情况</div>
        <div class="review-status-list">
          <div v-for="(item, index) in reviewStatusList" :key="index" class="review-status-item">
            <div>姓名：{{ item.name }}</div>
            <div>合计：{{ item.total }}</div>
            <div>已评：{{ item.review_num }}</div>
            <div>未评：{{ item.no_review_num }}</div>
          </div>
        </div>
      </div>
    </Modal>

    <!-- 反馈内容弹窗 -->
    <Modal
      :show-modal="showModal2"
      :show-confirm="false"
      cancel-text="关闭"
      @cancel="showModal2 = false"
    >
      <div style="max-height: 50vh;overflow: auto;">{{ content }}</div>
    </Modal>

    <!-- 详情抽屉 -->
    <Detail v-if="showDetail" :id="detailId" @hideDetail="hideDetail" />
  </div>
</template>
<script>
import { reviewsSearchBefore, reviewsNominationSearch, reviewsUpdateWhole } from '@/api/judge'
import { getPageKey, setPageKey } from '@/utils/auth'
import PreviewImage from '@/views/components/PreviewImage'
import Modal from '@/views/components/Modal.vue'
import Detail from '@/views/admin/judgeRe/detail.vue'

const columns = [
  {
    title: '序号',
    dataIndex: 'index',
    scopedSlots: { customRender: 'index' },
    width: '70px'
  },
  {
    title: '类别',
    dataIndex: 'category_id',
    scopedSlots: { customRender: 'category' }
  },
  {
    title: '作品图片',
    dataIndex: 'image',
    scopedSlots: { customRender: 'image' },
    width: '90px'
  },
  {
    title: '作品编号',
    dataIndex: 'pi_code',
    scopedSlots: { customRender: 'code' }
  },
  {
    title: '作品名称',
    scopedSlots: { customRender: 'name_cn' },
    dataIndex: 'name_cn'
  },
  {
    title: '分数',
    dataIndex: 'score',
    scopedSlots: { customRender: 'score' },
    width: '100px',
    sorter: true
  },
  {
    title: '反馈 ▼',
    dataIndex: 'feedback',
    scopedSlots: { customRender: 'feedback' },
    width: '100px'
  }
]

export default {
  components: {
    PreviewImage,
    Modal,
    Detail
  },
  data() {
    return {
      columns,
      users: [],
      cates: [],
      list: [],
      result: {
        total: 0,
        review_num: 0,
        no_review_num: 0,
        type03: 0,
        type36: 0,
        type67: 0,
        type78: 0,
        type89: 0,
        type91: 0
      },
      images: [],
      imagesIndex: 0,
      previewVisible: false,
      status: 0,
      user_id: 0,
      cate_ids: -1,
      searchWord: '',
      searchWord2: '',
      pagination: {
        current: 1,
        total: 0
      },
      feedback_status: -1,
      showModal2: false,
      content: '',
      showReviewStatusModal: false,
      reviewStatusList: [],
      result2: [],
      showDetail: false,
      detailId: 0
    }
  },
  computed: {
    catesFormat() {
      var json = {}
      for (const i in this.cates) {
        json[this.cates[i].value] = this.cates[i].name
      }
      return json
    },
    locale() {
      return this.$i18n.locale
    },
    user() {
      return this.$store.getters.user
    },
    listFilter() {
      return this.list.filter((item) => {
        item.name_cn = item.name_cn || ''
        item.name_en = item.name_en || ''
        return (this.feedback_status === -1 || item.feedback) &&
          (item.pi_code.indexOf(this.searchWord) !== -1 || item.name_cn.indexOf(this.searchWord) !== -1 || item.name_en.indexOf(this.searchWord) !== -1) &&
          (this.cate_ids === -1 ? true : this.cate_ids === item.category_id)
      })
    }
  },
  watch: {
    locale(e) {
      this.columns[0].title = this.$t('admin-judge/index')
      this.columns[1].title = this.$t('admin-profile-product/type')
      this.columns[2].title = this.$t('admin-profile-product/images')
      this.columns[3].title = this.$t('admin-judge/code')
      this.columns[4].title = this.$t('user-productInfo-product/productName')
      this.columns[5].title = this.$t('admin-judge/score')
    },
    listFilter() {
      this.pagination.current = 1
      this.pagination.total = this.listFilter.length
    }
  },
  created() {
    this.columns[0].title = this.$t('admin-judge/index')
    this.columns[1].title = this.$t('admin-profile-product/type')
    this.columns[2].title = this.$t('admin-profile-product/images')
    this.columns[3].title = this.$t('admin-judge/code')
    this.columns[4].title = this.$t('user-productInfo-product/productName')
    this.columns[5].title = this.$t('admin-judge/score')

    if (this.$route.query.judgeConfirmTip) {
      this.$info({ content: this.$t('admin-judge/tip11') })
      this.$router.push({ query: {}})
    }

    let params = getPageKey('judgeReScore')
    if (params) {
      params = JSON.parse(params)
      this.user_id = this.user.role === 3 ? this.user.id : (params && params.user_id ? Number(params.user_id) : 0)
    }

    reviewsSearchBefore(2, this.user_id || '').then(res => {
      this.users = res.users
      this.user_id = this.user.role === 3 ? this.user.id : (params && params.user_id ? Number(params.user_id) : res.users[0].id)
      this.cates = res.cates

      this.getList()
      if (params) {
        setTimeout(() => {
          if (params.current) this.pagination.current = Number(params.current)
          if (params.searchWord2) {
            this.searchWord2 = params.searchWord2 || ''
            this.searchWord = params.searchWord2 || ''
          }
          if (params.cate_ids) this.cate_ids = Number(params.cate_ids)
          // 如果路由 query 中带有 category_id（来自列表页点击某类别），作为初始 cate_ids
          if (this.$route.query && this.$route.query.category_id && !params.cate_ids) {
            this.cate_ids = Number(this.$route.query.category_id)
          }
        }, 300)
      } else {
        // 无缓存参数时，尝试从路由 query 初始化 cate_ids
        if (this.$route.query && this.$route.query.category_id) {
          this.cate_ids = Number(this.$route.query.category_id)
        }
      }
    })
  },
  mounted() {
    const el = document.getElementsByClassName('ant-table-column-sorter-inner')[0]
    if (el) el.removeAttribute('title')
  },
  methods: {
    // 显示评审情况弹窗
    showReviewStatus() {
      if (this.result2 && this.result2.length > 0) {
        this.reviewStatusList = this.result2
        this.showReviewStatusModal = true
      } else {
        this.$message.info('暂无评审情况数据')
      }
    },
    // 获取评审情况数据（如果后端返回）
    getReviewStatus() {
      if (this.result && this.result.result2) {
        this.result2 = this.result.result2
      }
    },
    getList(page, filters, sorter) {
      if (page && page.current && page.current !== this.pagination.current) {
        this.changePage(page)
        return
      }
      const data = {
        user_id: this.user_id,
        sort: sorter && sorter.order === 'ascend' ? 'asc' : 'desc'
      }
      // 仅在选择了具体类别时传入单一的 category_id；未选择时不传该参数
      if (this.cate_ids !== -1 && this.cate_ids != null) {
        data.category_id = this.cate_ids
      }
      reviewsNominationSearch(data).then(res => {
        this.status = res.status
        this.list = res.lists
        this.result = res.result
        if (res.result2) {
          this.result2 = res.result2
        }
        this.pagination.current = 1
      })
    },
    changePage(page) {
      this.setPageKey('current', page.current)
      this.pagination.current = page.current
    },
    changePerson() {
      this.setPageKey('user_id', this.user_id)
      reviewsSearchBefore(2, this.user_id).then(res => {
        this.cates = res.cates
        this.$set(this, 'cate_ids', -1)
        this.getList()
      })
    },
    confirm() {
      const that = this
      this.$confirm({
        content: `恭喜您完成复评环节，您共计复评${this.list.length}件作品。提交复评结果后将无法再进行修改，请确认是否提交。`,
        okText: this.$t('view-components-components/confirm'),
        cancelText: this.$t('admin-profile-edit/cancel'),
        onOk() {
          const data = { lists: JSON.parse(JSON.stringify(that.list)) }
          reviewsUpdateWhole(that.user_id, 2, data).then(res => {
            that.status = 1
            that.$message.success({ content: that.$t('view-components-components/submitTip'), key: 'message', duration: 4 })
            that.$router.push({ query: {}})
          })
        },
        onCancel() {}
      })
    },
    preview(images) {
      this.images = images.map(i => i.whole_image_url)
      this.imagesIndex = 0
      this.previewVisible = true
    },
    closePreview() {
      this.previewVisible = false
    },
    view(row) {
      this.detailId = row.id
      this.showDetail = true
    },
    hideDetail() {
      const current = this.pagination.current
      this.getList()
      setTimeout(() => {
        this.pagination.current = current
        this.showDetail = false
      }, 500)
    },
    changeCateId(value) {
      this.setPageKey('cate_ids', value)
    },
    changeWord(e) {
      this.setPageKey('searchWord2', e.target.value)
    },
    setPageKey(key, value) {
      let pageKey = getPageKey('judgeReScore') || '{}'
      pageKey = JSON.parse(pageKey)
      pageKey[key] = value
      setPageKey('judgeReScore', JSON.stringify(pageKey))
    }
  }
}
</script>
<style scoped>
  .table {
    margin-top: 30px;
  }

  .content {
    overflow: hidden;
    text-overflow:ellipsis;
    white-space:nowrap;
    width: 30vw;
  }

  footer{
    text-align: center;
    padding: 19px 0 39px;
  }

  footer button {
    margin-left: 16px;
  }

  .searchBox {
    padding: 17px 20px;
    background: #ffffff;
    margin-bottom: 10px;
  }

  .tag {
    width: 4em;
    line-height: 32px;
  }

  .review-status-list {
    max-height: 400px;
    overflow-y: auto;
  }
  .review-status-item {
    display: flex;
    justify-content: space-between;
    padding: 10px;
    border-bottom: 1px solid #eee;
  }
  .review-status-item:last-child {
    border-bottom: none;
  }
</style>
<style>
  .judgeReScoreDetail .ant-select-selection__rendered {
    margin-right: 22px;
  }
  .judgeReScoreDetail .ant-select-selection__rendered ul li+li{
    visibility: hidden;
    height: 0 !important;
    margin: 0 !important;
    border: 0 !important;
  }
  .judgeReScoreDetail .ant-select-selection__rendered ul li {
    pointer-events: none;
  }
  .judgeReScoreDetail .ant-select-selection__rendered ul li .ant-select-selection__choice__remove {
    pointer-events: auto;
  }
</style>
